// extracted by mini-css-extract-plugin
export var accordion = "_fu-0";
export var chevron = "_fu-3";
export var closed = "_fu-2";
export var content = "_fu-4";
export var open = "_fu-1";
export var rotate = "_fu-5";